// extracted by mini-css-extract-plugin
export default {"container":"HelpSupport_container__ZSNXC","main":"HelpSupport_main__azIRi","body":"HelpSupport_body__l4OoT","inputField":"HelpSupport_inputField__ExSZZ"};